import { Operator } from 'types';

import { createCrudApi } from './crud.api';

const { getAll } = createCrudApi<Operator>('/operators');

export const operatorsApi = {
  getAll,
};
